// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__ROtjY","title":"ClientInsurance_title__Lt7Lo","itemText":"ClientInsurance_itemText__2vsOp"};